













































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import IRPTParameters from '@/store/models/IRPTParameters';
import IRPTQueries from '@/store/models/IRPTQueries';
import IRPTQueriesParameters from '@/store/models/IRPTQueriesParameters';
import IRPTRepports from '@/store/models/IRPTRepports';
import IRPTRepportsQueries from '@/store/models/IRPTRepportsQueries';
import RPTParametersApi from '@/store/api/RPTParametersApi';
import RPTQueriesApi from '@/store/api/RPTQueriesApi';
import RPTQueriesParametersApi from '@/store/api/RPTQueriesParametersApi';
import RPTRepportsApi from '@/store/api/RPTRepportsApi';
import RPTRepportsQueriesApi from '@/store/api/RPTRepportsQueriesApi';
import RPTParametersSelector from '@/components/selectors/Printing/RPTParametersSelector.vue';
import RPTQueriesSelector from '@/components/selectors/Printing/RPTQueriesSelector.vue';
import RPTRepportsSelector from '@/components/selectors/Printing/RPTRepportsSelector.vue';
import RPTQueriesParametersSelector from '@/components/selectors/Printing/RPTQueriesParametersSelector.vue';
import RPTRepportsQueriesSelector from '@/components/selectors/Printing/RPTRepportsQueriesSelector.vue';
import ICompany from '@/store/models/ICompany';
import CompanyApi from '@/store/api/CompanyApi';
@Component({
    components: {
        Snackbar,
        RPTParametersSelector,
        RPTQueriesSelector,
        RPTRepportsSelector,
        RPTQueriesParametersSelector,
        RPTRepportsQueriesSelector
    }
})
export default class Printing extends Vue {
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    RPTParametersApi: RPTParametersApi;
    RPTQueriesApi: RPTQueriesApi;
    RPTQueriesParametersApi: RPTQueriesParametersApi;
    RPTRepportsApi: RPTRepportsApi;
    RPTRepportsQueriesApi: RPTRepportsQueriesApi;
    RPTParametersList: IRPTParameters[] = [];
    RPTQueriesList: IRPTQueries[] = [];
    RPTRepportsList: IRPTRepports[] = [];
    RPTQueriesParametersList: IRPTQueriesParameters[] = [];
    RPTRepportsQueriesList: IRPTRepportsQueries [] = [];
    CompanyApi: CompanyApi;
    CompanyList: ICompany[] = [];
    overlay: boolean = false;

    constructor() {
        super();
        this.RPTParametersApi = new RPTParametersApi();
        this.RPTQueriesApi = new RPTQueriesApi();
        this.RPTQueriesParametersApi = new RPTQueriesParametersApi();
        this.RPTRepportsApi = new RPTRepportsApi();
        this.RPTRepportsQueriesApi = new RPTRepportsQueriesApi();
        this.CompanyApi = new CompanyApi();
    }

    created() {
        this.getPermissions();
        this.getCompanies();
        this.getRPTParameters();
        this.getRPTQueries();
        this.getRPTRepports();
        this.getRPTQueriesParameters();
        this.getRPTRepportsQueries();
    }

    getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Settings"));
    }

    async getCompanies() {
        this.CompanyList = await this.CompanyApi.GetCompaniesById(this.idCompany);
    }

    async getRPTParameters() {
        this.RPTParametersList = await this.RPTParametersApi.GetRPTParameters();
    }

    async editRPTParameters(rptParameter: IRPTParameters) {
        this.overlay = true;
        let result : boolean = await this.RPTParametersApi.UpdateRPTParameters(rptParameter);
        if (result) {
            this.showMessageInfo(`The parameter ${rptParameter.parameterName} has been successfully edited`);
        } else {
            const errors: string = this.RPTParametersApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveRPTParameters(rptParameter: IRPTParameters) {
        this.overlay = true;
        const id = await this.RPTParametersApi.SaveRPTParameters(rptParameter);
        if (id) {
            rptParameter.id = id;
            this.RPTParametersList = [rptParameter].concat(this.RPTParametersList);
            this.showMessageInfo(`The parameter ${rptParameter.parameterName} has been successfully saved`);
        } else {
            const errors: string = this.RPTParametersApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteRPTParameters(item: IRPTParameters) {
        confirm('Are you sure you want to delete this parameter?') && this.deleteRPTParametersItem(item);
    }

    async deleteRPTParametersItem(rptParameters: IRPTParameters) {
        this.overlay = true;
        let result: boolean = await this.RPTParametersApi.DeleteRPTParameters(rptParameters.id);
        if (result) {
            const index = this.RPTParametersList.indexOf(rptParameters);
            this.RPTParametersList.splice(index, 1);
            this.showMessageInfo(`The parameter ${rptParameters.parameterName} has been successfully deleted`);
        } else {
            const errors: string = this.RPTParametersApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getRPTQueries() {
        this.RPTQueriesList = await this.RPTQueriesApi.GetRPTQueries();
    }

    async editRPTQueries(rptQueries: IRPTQueries) {
        this.overlay = true;
        let result : boolean = await this.RPTQueriesApi.UpdateRPTQueries(rptQueries);
        if (result) {
            this.showMessageInfo(`The query ${rptQueries.queryName} has been successfully edited`);
        } else {
            const errors: string = this.RPTQueriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveRPTQueries(rptQueries: IRPTQueries) {
        this.overlay = true;
        const id = await this.RPTQueriesApi.SaveRPTQueries(rptQueries);
        if (id) {
            rptQueries.id = id;
            this.RPTQueriesList = [rptQueries].concat(this.RPTQueriesList);
            this.showMessageInfo(`The query ${rptQueries.queryName} has been successfully saved`);
        } else {
            const errors: string = this.RPTQueriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteRPTQueries(item: IRPTQueries) {
        confirm('Are you sure you want to delete this query?') && this.deleteRPTQueriesItem(item);
    }

    async deleteRPTQueriesItem(rptQueries: IRPTQueries) {
        this.overlay = true;
        let result: boolean = await this.RPTQueriesApi.DeleteRPTQueries(rptQueries.id);
        if (result) {
            const index = this.RPTQueriesList.indexOf(rptQueries);
            this.RPTQueriesList.splice(index, 1);
            this.showMessageInfo(`The query ${rptQueries.queryName} has been successfully deleted`);
        } else {
            const errors: string = this.RPTQueriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }
    
    async getRPTQueriesParameters() {
        this.RPTQueriesParametersList = await this.RPTQueriesParametersApi.GetRPTQueriesParameters();
    }

    async editRPTQueriesParameters(rptQueriesParameters: IRPTQueriesParameters) {
        this.overlay = true;
        let result : boolean = await this.RPTQueriesParametersApi.UpdateRPTQueriesParameters(rptQueriesParameters);
        if (result) {
            this.showMessageInfo(`The query parameter has been successfully edited`);
        } else {
            const errors: string = this.RPTQueriesParametersApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveRPTQueriesParameters(rptQueriesParameters: IRPTQueriesParameters) {
        this.overlay = true;
        const id = await this.RPTQueriesParametersApi.SaveRPTQueriesParameters(rptQueriesParameters);
        if (id) {
            rptQueriesParameters.id = id;
            this.RPTQueriesParametersList = [rptQueriesParameters].concat(this.RPTQueriesParametersList);
            this.showMessageInfo(`The query parameter has been successfully saved`);
        } else {
            const errors: string = this.RPTQueriesParametersApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteRPTQueriesParameters(item: IRPTQueriesParameters) {
        confirm('Are you sure you want to delete this query parameter?') && this.deleteRPTQueriesParametersItem(item);
    }

    async deleteRPTQueriesParametersItem(rptQueriesParameters: IRPTQueriesParameters) {
        this.overlay = true;
        let result: boolean = await this.RPTQueriesParametersApi.DeleteRPTQueriesParameters(rptQueriesParameters.id);
        if (result) {
            const index = this.RPTQueriesParametersList.indexOf(rptQueriesParameters);
            this.RPTQueriesParametersList.splice(index, 1);
            this.showMessageInfo(`The query parameter has been successfully deleted`);
        } else {
            const errors: string = this.RPTQueriesParametersApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getRPTRepports() {
        this.RPTRepportsList = await this.RPTRepportsApi.GetRPTRepports();
    }

    async editRPTRepports(rptRepports: IRPTRepports) {
        this.overlay = true;
        let result : boolean = await this.RPTRepportsApi.UpdateRPTRepports(rptRepports);
        if (result) {
            this.showMessageInfo(`The repport ${rptRepports.repportName} has been successfully edited`);
        } else {
            const errors: string = this.RPTRepportsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveRPTRepports(rptRepports: IRPTRepports) {
        this.overlay = true;
        const id = await this.RPTRepportsApi.SaveRPTRepports(rptRepports);
        if (id) {
            rptRepports.id = id;
            this.RPTRepportsList = [rptRepports].concat(this.RPTRepportsList);
            this.showMessageInfo(`The repport ${rptRepports.repportName} has been successfully saved`);
        } else {
            const errors: string = this.RPTRepportsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    deleteRPTRepports(item: IRPTRepports) {
        confirm('Are you sure you want to delete this repport?') && this.deleteRPTRepportsItem(item);
    }

    async deleteRPTRepportsItem(rptRepports: IRPTRepports) {
        this.overlay = true;
        let result: boolean = await this.RPTRepportsApi.DeleteRPTRepports(rptRepports.id);
        if (result) {
            const index = this.RPTRepportsList.indexOf(rptRepports);
            this.RPTRepportsList.splice(index, 1);
            this.showMessageInfo(`The repport ${rptRepports.repportName} has been successfully deleted`);
        } else {
            const errors: string = this.RPTRepportsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getRPTRepportsQueries() {
        this.RPTRepportsQueriesList = await this.RPTRepportsQueriesApi.GetRPTRepportsQueries();
    }

    async editRPTRepportsQueries(rptRepportsQueries: IRPTRepportsQueries) {
        this.overlay = true;
        let result : boolean = await this.RPTRepportsQueriesApi.UpdateRPTRepportsQueries(rptRepportsQueries);
        if (result) {
            this.showMessageInfo(`The repport query has been successfully edited`);
        } else {
            const errors: string = this.RPTRepportsQueriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveRPTRepportsQueries(rptRepportsQueries: IRPTRepportsQueries) {
        this.overlay = true;
        const id = await this.RPTRepportsQueriesApi.SaveRPTRepportsQueries(rptRepportsQueries);
        if (id) {
            rptRepportsQueries.id = id;
            this.RPTRepportsQueriesList = [rptRepportsQueries].concat(this.RPTRepportsQueriesList);
            this.showMessageInfo(`The repport query has been successfully saved`);
        } else {
            const errors: string = this.RPTRepportsQueriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = true;
    }

    deleteRPTRepportsQueries(item: IRPTRepportsQueries) {
        confirm('Are you sure you want to delete this repport query?') && this.deleteRPTRepportsQueriesItem(item);
    }

    async deleteRPTRepportsQueriesItem(rptRepportsQueries: IRPTRepportsQueries) {
        this.overlay = true;
        let result: boolean = await this.RPTRepportsQueriesApi.DeleteRPTRepportsQueries(rptRepportsQueries.id);
        if (result) {
            const index = this.RPTRepportsQueriesList.indexOf(rptRepportsQueries);
            this.RPTRepportsQueriesList.splice(index, 1);
            this.showMessageInfo(`The repport query has been successfully deleted`);
        } else {
            const errors: string = this.RPTRepportsQueriesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
